import { IKWFRoute } from '../../KWFMain';
import { CtrlPageItemView } from './pageitemview.ctrl';
import { SessionEvents } from '@common/rwf/rwfedit.common';
import { CompatibilityService } from '@common/services/compatibilityservice';
import { RwfBootstrap, IFDDI_Wizard_Create_New_DMS_Document } from '@common/rwf';
import { NavClientService, NavPageItem } from '@common/navdata';
import { NavSettingsService } from '@common/services/settingsservice';
import { FDDI_Wizard_Create_New_DMS_Document } from '@common/rwf/rwf.const';
import { Bind } from '@common/navkendo';
import { fn } from '@common/utils';

const GetWizardTemplate = () => CtrlPageItemView.Template("wzrd");

export class CtrlWizardItem extends CtrlPageItemView {
    static RouteName = "wizard";
    static Route: IKWFRoute = {
        HideBar: true,
        DescriptionFormula: "vm.Title",
        template: GetWizardTemplate,
        controller: CtrlWizardItem,
        controllerAs: 'vm',
        resolve: {
            "GUID": ["$route", ($route: ng.route.IRouteService) => $route.current.params["GUID"]],
            "extid": ["$route", ($route: ng.route.IRouteService) => $route.current.params["extid"]],
        }
    };
    static Directive = [function (): ng.IDirective {
        return {
            controller: ["$scope", "CompatibilityService", "RwfBootstrap", "NavClient", "NavSettings",
                ($scope, CompatibilityService, RwfBootstrap, NavClient, NavSettings) =>
                    new CtrlWizardItem($scope, CompatibilityService, RwfBootstrap, NavClient, NavSettings)],
            controllerAs: "vm",
            template: GetWizardTemplate,
            scope: {
                item: "=item"
            },
            link: ($scope, instanceElement, attributes, ctrl) => {
                if (attributes.reference) {
                    $scope.$parent[attributes.reference] = ctrl;
                    $scope.$on("$destroy", () => delete $scope.$parent[attributes.reference]);
                }
            }
        };
    }];

    static $inject = ["$scope", "CompatibilityService", "RwfBootstrap", "NavClient", "NavSettings", "GUID", "extid"];
    constructor($scope: ng.IScope,
        $c: CompatibilityService,
        $rwf: RwfBootstrap,
        NavClient: NavClientService,
        NavSettings: NavSettingsService,
        GUID?: any,
        extid?: any) {
        super($scope, $c, $rwf, NavClient, NavSettings, extid);
        var RegisterDisplayChange = (cb: Function) => Bind(this, cb, SessionEvents.displaychange);
        var Rendered = (root: JQuery) => this.onRenderedInDockZone(root);

        this.CurrentTitle = 'Vorkontierung';
        this.GetExternalUrl = (extid) => {
            const NavUrlInfo = this.$rwf.EnsureResolved().NavUrlInfo;
            const Query = fn.EncodeQueryData({ nav: NavUrlInfo.BaseUrl + NavUrlInfo.QueryString, company : NavUrlInfo.Mandant });
            return `./#/${CtrlWizardItem.RouteName}/${this.CurrItem.Model.GUID}/${extid}?${Query}`; };

        $rwf.Resolve.then((rwf) => {
            if (rwf.RwfSettings.User.IsStandalone) {
                this.Show = false;
                return;
            }
            return NavClient.GetPageClientInfo(this.PageName, rwf.NavUrlInfo.FullUrl).then(pageClient => {

                return NavClient.GetView(pageClient).then(view => {
                    if (view && view.Groups.length == 0) {
                        // No Visualization Defined!
                        this.View = null;
                        return;
                    }

                    $scope.$watch(() => $scope["item"], (newVal, oldVal) => {
                        if (!(newVal instanceof NavPageItem)) {
                            if (oldVal) {
                                this.SetwizardItem(undefined);
                            }
                            return;
                        }
                        this.SetwizardItem(newVal);
                    });

                    $scope.$on("$destroy", () => {
                        this.SetwizardItem(undefined);
                        RegisterDisplayChange = fn.ToFunc(fn.noop);
                        Rendered = fn.noop;
                    });

                    if (GUID) {
                        const loadItem = NavClient.LoadItem<IFDDI_Wizard_Create_New_DMS_Document>({
                            PageName: FDDI_Wizard_Create_New_DMS_Document,
                            NavUrl: rwf.NavUrlInfo.FullUrl,
                            Keys: { GUID: GUID }
                        }).then(w => {
                            if (!w) {
                                fn.error("Vorkontierung mit GUID '" + GUID + "' nicht gefunden.");
                            }
                            return w;
                        });
                        this.SetwizardItem(loadItem);
                    }

                    view.UserPersistToken = ["KWF", "ViewConfiguration", this.PageName + "_View"]; // Discern from default View for Settings Persistence!
                    this.ZonesOptions = {
                        DockOptions: undefined,
                        Register: RegisterDisplayChange,
                        Rendered: Rendered,
                        View: view,
                        Item: this.CurrItem
                    };
                    return this.View = view;
                });
            }).then(undefined, err => this.Error = fn.resolveToError(err));
        });
    }

    public SetwizardItem(item: NavPageItem | PromiseLike<NavPageItem>) {
        this.$c.when(item).then(wizard => {
            delete this.Error;
            if (wizard && wizard.PageName !== this.PageName) {
                wizard = undefined;
            }

            if (wizard) {
                wizard.Anchor.Readonly.SetForceAll(true);
            }
            this._CurrItem = wizard;

            // Trigger displayChange : Properties must match INavPageItemEditorOptions
            const ZonesOptions = this.ZonesOptions;
            if (ZonesOptions) {
                ZonesOptions.Item = wizard;
            }
            this.trigger(SessionEvents.displaychange, ZonesOptions);

            this.Show = !!this.CurrItem;
        }, err => {
            this.Error = fn.resolveToError(err);
        });
    }

    public get CurrItem() { return this._CurrItem; }
    private _CurrItem: NavPageItem<IFDDI_Wizard_Create_New_DMS_Document>;
    readonly PageName = FDDI_Wizard_Create_New_DMS_Document;
}
